import { render, staticRenderFns } from "./InputComponent.vue?vue&type=template&id=0f39d172&scoped=true&"
import script from "./InputComponent.vue?vue&type=script&lang=ts&"
export * from "./InputComponent.vue?vue&type=script&lang=ts&"
import style0 from "./InputComponent.vue?vue&type=style&index=0&id=0f39d172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f39d172",
  null
  
)

export default component.exports